import { Link } from "react-router-dom";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { Button, Col, Label, Row } from "reactstrap";
import SkorHeader from "../components/SkorHeader";
import RekapNilaiKelompok from "../components/RekapNilaiKelompok";
import getEmailRekapIndividu from "../services/getEmailRekapIndividu";
import useAxios from "../../../Utils/useAxios";
import { useEffect, useState } from "react";
import getAsesmenKelompok from "../services/getAsesmenKelompok";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import getPredikatNilaiKelompok from "../services/getPredikatNilaiKelompok";
import getEmailRekapKelompok from "../services/getEmailRekapKelompok";
import SelectionFieldAssessedUnitKerja from "../components/SelectionFieldAssessedUnitKerja";
import {
  getName,
  getRole,
  getUnitKerjaStorage,
} from "../../../Utils/externalFunctions";

const RekapKelompokContain = () => {
  const axiosInstance = useAxios();
  const [data, setData] = useState({ asesmen: [], predikat: [] });

  const [selectedAssessedBy, setSelectedAssessedBy] = useState(
    getRole() !== "Admin" ? getUnitKerjaStorage() : ""
  );

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      rekapKelompok();
      refreshPredikat();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const rekapKelompok = () => {
    getAsesmenKelompok(axiosInstance).then((res) => {
      setData((prev) => ({ ...prev, asesmen: res.data }));
    });
  };

  const refreshPredikat = () => {
    getPredikatNilaiKelompok(axiosInstance).then((res) => {
      setData((prev) => ({ ...prev, predikat: res.data }));
    });
  };

  const sendEmail = () => {
    getEmailRekapKelompok(axiosInstance).then((res) => {
      toast.success(`GET Email Rekap Kelompok success`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
  };

  const updateAssessedBy = (newUnitKerja) =>
    setSelectedAssessedBy(newUnitKerja);

  return (
    <FeatureContainer>
      <div className="d-flex justify-content-between px-4">
        <Link to={`/dashboard/`}>
          <Button>Kembali ke Dashboard</Button>
        </Link>
        {/* <Button onClick={sendEmail}>Kirim ke Email</Button> */}
      </div>
      <Col
        sm={{
          offset: 1,
          size: 10,
        }}
      >
        <Label className={"d-flex justify-content-center h4"}>
          <strong>Rekap Penilaian Kinerja Kelompok</strong>
        </Label>
        <SkorHeader className={"py-4 w-75 mx-auto"} predikat={data.predikat} />
        {(getRole() === "Admin" || getName() === "Dr. Dina Chahyati") && (
          <Row>
            <Col className={"col-2"}>
              <strong>Unit kerja</strong>
            </Col>
            <Col>
              <div className="d-flex">
                :{" "}
                <SelectionFieldAssessedUnitKerja
                  updateAssessedBy={updateAssessedBy}
                />
              </div>
            </Col>
          </Row>
        )}
        <RekapNilaiKelompok
          data={data}
          selectedAssessedBy={selectedAssessedBy}
        />
      </Col>
    </FeatureContainer>
  );
};

export default RekapKelompokContain;
